export default "__VITE_ASSET__C32rAb_G__"